import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Steps, Button, Modal, Input, Form, Select, message } from "antd";
import { Map, List } from "immutable";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Table } from "components/table";
import { PAYPRO_PENDING_APPROVAL_COLS } from "constants/table-columns";
import {
    fetchPaymentProgramDetails,
} from "actions";
import { STATE_STATUS } from "constants/state-status";
import "styles/cibil-page.css";
import { CompanyService, PaymentProgramService } from "../services";
import { getDataFromQueryString } from "../utils";


const { Option } = Select;


const Tabs = Map({
    kycPending: {
        label: "KYC Pending",
        key: 1,
        id: 1,
        this_stage_id: 30
    },
    docsReview: {
        label: "Docs Review",
        key: 2,
        id: 2,
        this_stage_id: 31

    },
    approved: {
        label: "Approved",
        key: 3,
        id: 3,
        this_stage_id: 32
    },
});

class PaymentProgramTable extends React.Component {
    state = {
        associates: this.props.associates || new List([]),
        selectedTab: "1",
        currentPage: 1,
        updateModal: false,
        showAssignModal: false,
        selectedAgent: "",
        usersList: List(),
        userAssignRemarks: "",
        selfAssign: "",
        redirectBack: false,
        ppKycCount: {},
        action_detail_id: ""
    };

    pageSize = 20;
    selectedRows = List();


    componentDidMount() {
        PaymentProgramService.getPPKycCount().then(({ data }) => {
            let count = {};
            data && data.length && data.map(_ => count[_.this_stage_id] = _.count);
            this.setState({
                ppKycCount: count
            });
        });
        CompanyService.getUsersList("DBT").then(({ data }) => {
            this.setState({
                usersList: List(data)
            });
        });
        this.setState({
            selectedTab: getDataFromQueryString("ordering")
        });
        this.props.fetchPaymentProgramDetails(getDataFromQueryString("ordering"), this.state.currentPage, this.pageSize, {});
    }

    componentDidUpdate() {
        if (this.props.permissions.size && !this.state.redirectBack) {
            if (!this.props.permissions.get("page_dbt_bulk_assign") && !this.props.permissions.get("page_dbt_edit")) {
                this.setState({
                    redirectBack: true
                }, () => {
                    this.props.history.goBack();
                });
            }
        }
    }
    handleSubmit = () => {
        this.props.form.validateFields((err, fieldsValue) => {
            if (!err) {
                if (fieldsValue.contact_number.match(/^[0-9]{10}$/) && fieldsValue.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
                    try {
                        message.loading("Sending form please wait...");
                        /* eslint-disable */
                        PaymentProgramService.paymentProgramService(fieldsValue, JSON.stringify(this.state.action_detail_id)).then((res) => {
                            message.success("form submitted successfully");
                            if (res.status == 200) {
                                this.props.fetchPaymentProgramDetails(getDataFromQueryString("ordering"), this.state.currentPage, this.pageSize, {});

                            }
                        });

                    } catch (e) {
                        message.error("Error in sending form");
                    }

                    if (fieldsValue !== null) {
                        this.setState({ updateModal: false })

                    }
                }
                else if (!fieldsValue.contact_number.match(/^[0-9]{10}$/) && fieldsValue.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
                    message.error("please enter 10 digit phone number ")
                }
                else if (!fieldsValue.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/) && fieldsValue.contact_number.match(/^[0-9]{10}$/)) {
                    message.error("please enter valid email")
                }
                else if (!fieldsValue.contact_number.match(/^[0-9]{10}$/) && !fieldsValue.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
                    message.error("please enter valid email and phone number")
                }
            }
        })

    }

    onPageChange = (page, pageSize) => {
        this.pageSize = pageSize;
        this.setState({
            currentPage: page,
        }, () => {
            this.fetchPaymentProgram();
        });
    }

    onPageSizeChange = (page, pageSize) => {
        this.pageSize = pageSize;
        this.setState({
            currentPage: page,
        }, () => {
            this.fetchPaymentProgram();
        });
    }

    onFilter = (val) => {
        this.fetchPaymentProgram(val);
    }

    fetchPaymentProgram = (filters = {}) => {
        this.props.fetchPaymentProgramDetails(this.state.selectedTab, this.state.currentPage, this.pageSize, filters);

    }

    showEditModal = (id, record) => {
        this.setState({ action_detail_id: id })
        this.setState({
            updateModal: true
        });
    }

    onFormSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                console.log("Received values of form: ", values);
            }
        });

    }
    closeSplitModal = () => {
        this.setState({ updateModal: false })
    }

    getUpdateModal = () => {
        const { getFieldDecorator } = this.props.form;
        return (
            <Modal
                visible={this.state.updateModal}
                footer={null}
                // closable={true}
                width={700}
                destroyOnClose={true}
                onCancel={this.closeSplitModal}
            >
                <div className={"p-10 d-flex flex-column"}>
                    Update details
                    <Form className={"edit_pp_form_width"} onSubmit={this.onFormSubmit}>
                        <Form.Item
                            label={"Name"}
                            className="mr-10"
                        >
                            {getFieldDecorator("username", {
                                rules: [{ required: true, message: "Please input your username!" }],
                            })(
                                <Input
                                    placeholder="Username"
                                />,
                            )}
                        </Form.Item>
                        <Form.Item
                            label={"Contact No."}
                        >
                            {getFieldDecorator("contact_number", {
                                rules: [{ required: true, message: "Field is required" }],
                            })(
                                <Input
                                    placeholder="Contact Number"
                                />,
                            )}
                        </Form.Item>
                        {/* <Form.Item
                            label={"Dealer Code"}
                            className="mr-10"
                        >
                            {getFieldDecorator("dealer_code", {
                                rules: [{ required: true, message: "Field is required" }],
                            })(
                                <Input
                                    placeholder="Dealer Code"
                                />,
                            )}
                        </Form.Item>
                        <Form.Item
                            label={"Main Dealer Code"}
                        >
                            {getFieldDecorator("main_dealer_code", {
                                rules: [{ required: true, message: "Field is required" }],
                            })(
                                <Input
                                    placeholder="Main Dealer Code"
                                />,
                            )}
                        </Form.Item> */}
                        <Form.Item
                            label={"Email"}
                            className="mr-10"
                        >
                            {getFieldDecorator("email", {
                                rules: [{ required: true, message: "Field is required" }],
                            })(
                                <Input
                                    placeholder="Email"
                                />,
                            )}
                        </Form.Item>
                        <Form.Item style={{ width: "100%" }}>
                            <Button type="primary" htmlType="submit" onClick={this.handleSubmit}>
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        );
    }

    handleAssignCaseModal = () => {
        this.setState({
            showAssignModal: !this.state.showAssignModal,
            selectedAgent: "",
            userAssignRemarks: "",
            selfAssign: ""
        });
    }

    clearData = () => {
        this.selectedRows = List();
        this.setState({
            showAssignModal: !this.state.showAssignModal,
            selectedAgent: "",
            userAssignRemarks: "",
            selfAssign: ""
        });
    }

    assignCases = () => {
        const { selectedAgent, userAssignRemarks, currentPage, selfAssign } = this.state;
        if (selfAssign && userAssignRemarks.length) {
            PaymentProgramService.assignCaseSelf(selfAssign, userAssignRemarks, this.props.userDetails.id).then((response) => {
                if (response.status === 200) {
                    message.success("Case Assigned Successfully");
                    this.props.fetchPaymentProgramDetails(getDataFromQueryString("ordering"), currentPage, this.pageSize, {});
                }
                this.clearData();
            }).catch((err) => {
                this.clearData();
                if (err.non_field_errors) {
                    message.error(err.non_field_errors[0]);
                } else {
                    message.error("Something went wrong!");
                }
            });

        } else if (selectedAgent && userAssignRemarks.length && this.selectedRows.size) {
            message.loading("Case Assigning ... ");
            PaymentProgramService.bulkAssignCases(this.selectedRows, userAssignRemarks, selectedAgent).then((response) => {
                if (response.status === 200) {
                    message.success("Case Assigned Successfully");
                    this.handleAssignCaseModal();
                    this.selectedRows = List();
                    this.props.fetchPaymentProgramDetails(getDataFromQueryString("ordering"), currentPage, this.pageSize, {});
                }
            }).catch((err) => {
                this.clearData();
                if (err.non_field_errors) {
                    message.error(err.non_field_errors[0]);
                } else {
                    message.error("Something went wrong!");
                }
            });
        }
    }

    onRowSelection = (_) => {
        let filterTotalRow = _.filter(_ => (_));
        this.selectedRows = filterTotalRow;
        this.forceUpdate();
    }

    renderAssignCasesModal = () => {
        const { permissions } = this.props;
        return (
            <Modal
                title="Assign Cases"
                visible={this.state.showAssignModal}
                onOk={this.assignCases}
                onCancel={this.handleAssignCaseModal}
            >
                {!this.state.selfAssign && permissions.size && permissions.get("page_dbt_bulk_assign") &&
                    <>
                        <label>Select Agent</label>
                        <Select placeholder="Select Agent" className="mb-10 mt-5" value={this.state.selectedAgent || undefined} onChange={(_) => this.setState({ selectedAgent: _ })} style={{ width: "100%" }}>
                            {this.state.usersList.size && this.state.usersList.map((_, k) => (
                                <Option value={_.id} key={k}>{_.full_name}</Option>
                            ))}
                        </Select>
                    </>
                }
                <label style={{ marginTop: 15 }}>Remarks</label>
                <textarea
                    rows="4"
                    className="mt-5 w-100"
                    style={{
                        borderColor: "#d9d9d9"
                    }}
                    value={this.state.userAssignRemarks}
                    onChange={(_) => this.setState({ userAssignRemarks: _.target.value })}
                />
            </Modal>
        );
    }
    selfAssignCase = (id) => {
        this.setState({
            selfAssign: id,
            showAssignModal: !this.state.showAssignModal,
            selectedAgent: "",
            userAssignRemarks: ""
        });
    }

    get showRowSelection() {
        const { permissions } = this.props;
        if (Number(this.state.selectedTab) !== 2 || !(permissions.size && permissions.get("page_dbt_bulk_assign"))) {
            return true;
        } else {
            return false;
        }
    }

    docSubmittedTable = () => {
        const { status } = this.props;
        const { associates, permissions } = this.props;
        let filterActionColumns = PAYPRO_PENDING_APPROVAL_COLS.filter(_ => _.key !== "split");
        return (
            <Table
                columns={[1, 2].includes(Number(this.state.selectedTab)) ? PAYPRO_PENDING_APPROVAL_COLS : filterActionColumns}
                checkedColumns={[]}
                filterColumns={PAYPRO_PENDING_APPROVAL_COLS.filter(_ => _.is_filter_applicable).map(_ => _.dataIndex).toList().toArray()}
                data={associates.size ? associates
                    .map(_ => {
                        let row = _;
                        row.split = ([
                            Number(this.state.selectedTab) == 1 ? <Button type={"link"} onClick={this.showEditModal.bind(null, _.onboarding_id, _)} className={"leftBorder"}>Edit</Button> : <></>,
                            Number(this.state.selectedTab) == 2 && permissions.size && permissions.get("page_dbt_edit") && <Button type={"link"} size={"small"} onClick={this.selfAssignCase.bind(null, _.id)}> Assign</Button>
                        ]);
                        return row;
                    })
                    .toList() : List()
                }
                // showTitle={false}
                showFooter={false}
                showPaginationOnly={false}
                showCustomButton={this.selectedRows.size}
                selectedRowKeys={this.selectedRows}
                bulkActionSelectedKey={"id"}
                customButtonTexts={["Assign"]}
                custonButtonIcons={[]}
                noRowSelection={this.showRowSelection}
                onCustomButtonClicks={[this.handleAssignCaseModal]}
                showTopSection={true}
                keyFilter={"id"}
                onFilter={this.onFilter}
                onRowSelection={this.onRowSelection}
                showColumnSelector={false}
                showHeader={true}
                pagination={{
                    current: this.state.currentPage,
                    showSizeChanger: true,
                    defaultPageSize: 20,
                    pageSizeOptions: [
                        "10",
                        "20",
                        "50",
                        "100",
                        "500"
                    ],
                    position: "bottom",
                    total: this.props.currentTabCount,
                    onChange: (page, pageSize) =>
                        this.onPageChange(page, pageSize),
                    onShowSizeChange: this.onPageSizeChange,
                }}
                loading={
                    status !== STATE_STATUS.FETCHED &&
                    status !== STATE_STATUS.UPDATED
                }
                editable={true}
                className={"inbox-table"}
            />
        );
    }

    onChangeTab = activeIndex => {
        const stage = Tabs.toList().find((_, index) => index === activeIndex);
        this.setState({
            selectedTab: stage.id,
            currentPage: 1,
        }, () => {
            this.props.history.replace(
                `/app/payment-program/?ordering=${stage.id}`
            );
            this.forceUpdate();
            this.props.fetchPaymentProgramDetails(this.state.selectedTab, this.state.currentPage, this.pageSize, {});
        });
    }


    render() {
        return (
            <Row >
                <Col span={24} className={"p-5"}>
                    <Steps
                        className={"stage-tabs normal-steps-height"}
                        type={"navigation"}
                        size={"small"}
                        current={Tabs.toList().findIndex((_) => _.id === Number(this.state.selectedTab))}
                        onChange={this.onChangeTab}
                        style={{
                            marginBottom: 10,
                            boxShadow: "0px -1px 0 0 #e8e8e8 inset",
                            overflowX: "scroll"
                        }}
                    >
                        {Tabs.map(_ => {
                            return (<Steps.Step
                                status={null}
                                key={_.id}
                                title={
                                    <div className="d-flex justify-content-space-between" style={{
                                        alignItems: "start",
                                        width: "100%"
                                    }}>
                                        <div>{_.label}<span>    ({this.state.ppKycCount[_.this_stage_id] || 0})</span></div>
                                    </div>
                                }
                            />);
                        }).toList()}
                    </Steps>
                    {this.docSubmittedTable()}
                    {this.getUpdateModal()}
                    {this.renderAssignCasesModal()}
                </Col>
            </Row>
        );
    }
}

PaymentProgramTable.propTypes = {
    associates: PropTypes.object,
    status: PropTypes.string,
    save: PropTypes.bool,
    update: PropTypes.func,
    fetchPaymentProgramDetails: PropTypes.func,
    updateCibilDetails: PropTypes.func,
    currentTabCount: PropTypes.number,
    history: PropTypes.object,
    form: PropTypes.object,
    permissions: PropTypes.object,
    userDetails: PropTypes.object
};

PaymentProgramTable.defaultProps = {
    associates: new Map({}),
    currentTabCount: 0
};

const mapStateToProps = (state) => {
    let currentOpenTab = state.paymentProgramDetails && state.paymentProgramDetails.get("current_tab");
    return {
        status: state.paymentProgramDetails && state.paymentProgramDetails.getIn([currentOpenTab, "status"]),
        associates: state.paymentProgramDetails && state.paymentProgramDetails.getIn([currentOpenTab, "data"]),
        currentTabCount: state.paymentProgramDetails && state.paymentProgramDetails.getIn([currentOpenTab, "count"]),
        permissions: state.user.get("permissions"),
        userDetails: state.user.get("data")
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators({
        fetchPaymentProgramDetails,
    }, dispatch);


export default Form.create({
    mapPropsToFields: ({ values }) =>
        values &&
        values.size &&
        values
            .map(value =>
                Form.createFormField({
                    value
                })
            )
            .toJS()
})(connect(mapStateToProps, mapDispatchToProps)(PaymentProgramTable));
